export function sanitizeModelId(model: string): string {
  return model.toLowerCase().replace(/[./]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '')
}

export function galleryFilename(
  model: string,
  date: Date = new Date(),
  ext: 'png' | 'mp4' = 'png',
): string {
  const dateStr = date.toISOString().slice(0, 10)
  return `byokapp-${dateStr}-${sanitizeModelId(model)}.${ext}`
}
